<template>
  <li :class="classList" />
</template>

<script>
export default {
  name: 'SidebarNavDivider',
  props: {
    classes: {
      type: [String, Array, Object],
      default: '',
    },
  },
  computed: {
    classList() {
      return [
        'nav-divider',
        ...this.itemClasses,
      ];
    },
    itemClasses() {
      const classes = this.classes;
      if (!classes) return [];
      if (typeof classes === 'string' || classes instanceof String) {
        return classes.split(' ');
      }
      if (Array.isArray(classes)) {
        return classes;
      }
      return Object.keys(classes).filter((i) => classes[i]);
    },
  },
};
</script>
